$(window).on('load', function(){
    if (window.sprCheck) {
        var id = $("#shopify-product-reviews").data('id'), 
            arrowPrev = $(`<a class="arrow-prev"><svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line y1="-0.934599" x2="15.4304" y2="-0.934599" transform="matrix(-0.71061 0.703586 0.71061 0.703586 13.2227 2.19873)" stroke="#6C6C6C" stroke-width="1.8692"/>
            <line y1="-0.934599" x2="15.4304" y2="-0.934599" transform="matrix(-0.71061 -0.703586 -0.71061 0.703586 12.4395 23.1362)" stroke="#6C6C6C" stroke-width="1.8692"/>
            </svg></a>`),
            arrowNext = $(`<a class="arrow-next"><svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line y1="-0.934599" x2="15.4304" y2="-0.934599" transform="matrix(0.71061 0.703586 -0.71061 0.703586 1.21289 2.19873)" stroke="#6C6C6C" stroke-width="1.8692"/>
            <line y1="-0.934599" x2="15.4304" y2="-0.934599" transform="matrix(0.71061 -0.703586 0.71061 0.703586 1.99609 23.1362)" stroke="#6C6C6C" stroke-width="1.8692"/>
            </svg>
            </a>`),
            count, currPage = 1, page, startPage, maxPage, isMaxRepeat = false, isMinRepeat = false;
        $.ajax({
            type: 'GET',
            url: 'https://productreviews.shopifycdn.com/proxy/v4/reviews/product?shop=luxreaders.myshopify.com&product_id=' + id,
            dataType: 'jsonp', // jsonp does the trick to avoid cross-origin-policy shit! https://www.sitepoint.com/jsonp-examples/
            success: function(resp) {
                var json = $("<script>").html(resp.aggregate_rating).text();
                json = $.parseJSON(json)
                count = json.reviewCount
                page = Math.ceil(count / 3);
                startPage = 1
                maxPage = page;
                $('div#shopify-product-reviews .spr-reviews .spr-pagination').remove();
                setTimeout(() => {
                    moveDate();
                }, 700);
            },
            error: function(jqXHR, textStatus, errorThrown) {
                console.log(jqXHR, textStatus, errorThrown);
            }
        });
    
        // isRepeat to prevent unwanted fetching
    
        setTimeout(() => {
            addRating();
            if (window.SPR) {
                // mobile
                // fetch all data to put them in one row
                if (window.matchMedia("(max-width: 767px)").matches) {
                    let slide = ""
                    function fetchData(page) {
                        return new Promise((res,rej)=>{
                            $.ajax({
                                dataType: 'jsonp', 
                                url: `https://productreviews.shopifycdn.com/proxy/v4/reviews?callback=paginateCallback${id}&page=${page}&product_id=${id}&shop=luxreaders.myshopify.com=1&shop=luxreaders.myshopify.com&product_ids[]=${id}`, 
                                success: function(result){
                                    res(result.reviews)
                                }
                            });
                        })
                    }
                    async function paginationGroup() {
                        for (let page = startPage; page <= maxPage; page++) {
                            var data = await fetchData(page)
                            slide += data
                        }
                        // the following cannot be done in once for both mobile and desktop because of fetch
                        $('div#shopify-product-reviews .spr-reviews').html(slide)
                        $('div#shopify-product-reviews .spr-reviews .spr-pagination').remove()
                        moveDate()
                    }
    
                    paginationGroup()
                }
                // initiating pagination elements
                // desktop
                var html = '<div class="pagination-arrows"></div>'
                paginationEl = $.parseHTML(html);
                $(paginationEl).append(arrowPrev)
                $(paginationEl).append(arrowNext)
                $(paginationEl).insertAfter($("div#shopify-product-reviews .spr-reviews"))
                if (page<=1) $("div#shopify-product-reviews .pagination-arrows").addClass("pagination-hidden");
    
                // pagination events
                $(arrowPrev).on("click", function(){
                    currPage<=startPage? (currPage=startPage) : currPage--;
                    if (currPage == startPage) {
                        isMaxRepeat = false;
                        !isMinRepeat && $.ajax({
                            dataType: 'jsonp', 
                            url: `https://productreviews.shopifycdn.com/proxy/v4/reviews?callback=paginateCallback${id}&page=${currPage}&product_id=${id}&shop=luxreaders.myshopify.com=1&shop=luxreaders.myshopify.com&product_ids[]=${id}`, 
                            success: function(res){
                                $('div#shopify-product-reviews .spr-reviews').html(res.reviews)
                                $('div#shopify-product-reviews .spr-reviews .spr-pagination').remove()
                                moveDate();
                        }});
                        isMinRepeat = true;
                    } else {
                        isMaxRepeat = false;
                        $.ajax({
                            dataType: 'jsonp',
                            url: `https://productreviews.shopifycdn.com/proxy/v4/reviews?callback=paginateCallback${id}&page=${currPage}&product_id=${id}&shop=luxreaders.myshopify.com=1&shop=luxreaders.myshopify.com&product_ids[]=${id}`, 
                            success: function(res){
                                $('div#shopify-product-reviews .spr-reviews').html(res.reviews)
                                $('div#shopify-product-reviews .spr-reviews .spr-pagination').remove()
                                moveDate();
                        }});
                    }
                })
                $(arrowNext).on("click", function(){
                    currPage>=maxPage? (currPage=maxPage) : currPage++;
                    if (currPage == maxPage) {
                        isMinRepeat = false;
                        !isMaxRepeat && $.ajax({
                            type: "GET",
                            dataType: 'jsonp', 
                            url: `https://productreviews.shopifycdn.com/proxy/v4/reviews?callback=paginateCallback${id}&page=${currPage}&product_id=${id}&shop=luxreaders.myshopify.com=1&shop=luxreaders.myshopify.com&product_ids[]=${id}`, 
                            success: function(res){
                                $('div#shopify-product-reviews .spr-reviews').html(res.reviews)
                                $('div#shopify-product-reviews .spr-reviews .spr-pagination').remove()
                                moveDate();
                        }});
                        isMaxRepeat = true;
                    } else {
                        isMinRepeat = false;
                        $.ajax({
                            type: "GET",
                            dataType: 'jsonp', 
                            url: `https://productreviews.shopifycdn.com/proxy/v4/reviews?callback=paginateCallback${id}&page=${currPage}&product_id=${id}&shop=luxreaders.myshopify.com=1&shop=luxreaders.myshopify.com&product_ids[]=${id}`, 
                            success: function(res){
                                $('div#shopify-product-reviews .spr-reviews').html(res.reviews)
                                $('div#shopify-product-reviews .spr-reviews .spr-pagination').remove()
                                moveDate();
                        }});                
                    }
                })
            }
        }, 1000);
        
        function addRating() {
            var ratingReg = /[+-]?\d+(\.\d+)?/g;
            var $ratingWrapper = $("div#shopify-product-reviews").find('.spr-starrating.spr-summary-starrating');
            // getting the overall rating
            var rating = $ratingWrapper.attr('aria-label')
            rating = rating.match(ratingReg)[0];
            var ratingHTML = `<p class="starrating-no">${rating}</p>`;
            $ratingWrapper.prepend(ratingHTML)
        };
    
        function moveDate() {
            $('div#shopify-product-reviews .spr-reviews .spr-review').each(function(){
                var info = /<strong>(.*?)<\/strong>/g;
                info = $(this).find('.spr-review-header-byline').html().match(info).map(function(val){
                    return val.replace(/<\/?strong>/g,'');
                    });;
                // conversion
                const name = info[0];
                const date = new Date(info[1]);
                var infoDiv = $('<div class="spr-info"></div>');
                var month = date.getMonth();
                var day = date.getDate();
                var year = date.getFullYear();
                var newDate = `${day}/${month+1}/${year}`
                var nameHTML = `<p class="spr-reviewer-name">${name}</p>`
                var dateHTML = `<p class="spr-reviewe-date">${newDate}</p>`
                infoDiv.append(nameHTML).append(dateHTML)
    
                // move name
                $(this).find('.spr-review-header-byline').remove()
                $(this).append(infoDiv)
            })
        }
    }
});